import renderRaffleJackpot from "../actions/renderRaffleJackpot";
import renderRaffleDeadline from "../actions/renderRaffleDeadline";

const PageRaffle = ($) => {
	renderRaffleJackpot($);
	renderRaffleDeadline($);
};

export default PageRaffle;
